import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
// import "./components/Questionnaire/";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import HeaderLayout from './HeaderLayout';
import ClarityIdentify from "./ClarityIdentify";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HeaderLayout />
      <ClarityIdentify/>
      <div style={{position:"relative",top:"16px"}}>
      <App />
      </div>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
